import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, Validators, FormGroup, FormArray } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";

// SERVICE
import { RolesPermisosService } from "../../../../services/roles_permisos.service";
import { PermisosService, PermisoModel, PermisoGet } from "../../../../services/permisos.service";
import { RolesService } from "src/app/services/roles.service";

@Component({
  selector: "app-rol",
  templateUrl: "./rol.component.html",
  styleUrls: ["./rol.component.scss"],
})
export class RolComponent implements OnInit {
  permisos: PermisoModel[] = []
  form: any = {}
  id_roles: number = this.data?.id_roles
  option:string = "Crear"

  constructor(
    private _snackBar: MatSnackBar,
    public _permisosService: PermisosService,
    public _rolesService: RolesService,
    public _rolesPermisosService: RolesPermisosService,
    public dialogRef: MatDialogRef<RolComponent>,
    @Inject(MAT_DIALOG_DATA) public data?: any,
  ){

  }

  ngOnInit() {
    this.identificarCrearOEditar()
    this._permisosService.obtenerTodos().subscribe((permisosData: PermisoGet) => { this.permisos = permisosData.payload});
  }

  async identificarCrearOEditar(){
    if(this.data){
      this.option = "Editar"
      this.form.name = await this.getNombreRol()
      this.setPermisos(await this.getPermisos())
    }
  }

  async getNombreRol(){
    return (await this._rolesService.getRol(this.id_roles).toPromise()).payload.nombre
  }

  async getPermisos(){
    return (await this._rolesPermisosService.obtenerId(this.data.id_roles).toPromise()).payload.data
  }

  setPermisos(permisos: PermisoModel[]){
    permisos.map((permiso: PermisoModel)=>{
      this.form[permiso.nombre] = true
    })
  }

  guardarPermisos(){
    try{
      this.validarNombreDelRol()
      if(!this.id_roles){
        this.crearRol()
      }else{
        this.actualizarRol()
      }
    }catch(err){
      this._snackBar.open(err,`x`)
    }
  }

  validarNombreDelRol(){
    /* Validations for name */
    if(!this.form.hasOwnProperty('name')) throw `Por favor coloque un nombre válido.`
    let name = this.form.name
    if(name.length < 1) throw 'Por favor coloque un nombre válido.'
  }

  crearRol(){
    this._rolesService.createRol({
      nombre:this.form.name,
      borrado: 0,
      id_usuarios_creador: sessionStorage.getItem('id_usuario'),
      estatus:true
    }).subscribe((res: any)=>{
      this.crearRolesPermisos(res.payload.id_roles)
    },error => {
      this._snackBar.open(error.error.payload,`x`)
    })
  }

  getIdArrPermisos(){
    let arrPermisos = []
    for(let key of Object.keys(this.form)){
      if(key !== 'name'){
        let permiso: PermisoModel = this.permisos.find((permiso: PermisoModel)=> permiso.nombre === key)
        if(permiso && this.form[key] === true){
          arrPermisos.push(permiso.id_permisos)
        }
      }
    }
    return arrPermisos
  }

  crearRolesPermisos(id_roles:number){
    let arrPermisos = this.getIdArrPermisos()
    this._rolesPermisosService.crear({id_roles:id_roles,permisos:arrPermisos}).subscribe((res: any)=>{
    })
  }
  editarRolesPermisos(id_roles:number){
    let arrPermisos = this.getIdArrPermisos()
    this._rolesPermisosService.actualizar({id_roles:id_roles,permisos:arrPermisos}).subscribe((res: any)=>{
    })
  }

  actualizarRol(){
    this._rolesService.updateRol(this.id_roles,{
      id_roles: this.id_roles,
      nombre:this.form.name,
      borrado: 0,
      id_usuarios_creador: sessionStorage.getItem('id_usuario'),
      estatus:true
    }).subscribe((res: any)=>{
      this.editarRolesPermisos(this.id_roles)
      this.dialogRef.close()
    },error => {
      this._snackBar.open(error.error.payload,`x`)
    })
  }

}

